import { Component, OnInit } from '@angular/core';
import { TBinaryComponent } from '../t-binary/t-binary.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';


@Component({
  selector: 'app-t-binary-insert',
  templateUrl: './t-binary-insert.component.html',
  styleUrls: ['../t-binary/t-binary.component.css','./t-binary-insert.component.css']
})
export class TBinaryInsertComponent extends TBinaryComponent {

  constructor(protected topicService: TopicService, protected activatedRoute:ActivatedRoute, protected http: HttpClient) {
    super(topicService, activatedRoute, http);
    this.type = "binaryInsert";
    this.title = this.get("binaryInsertTitle");
   }

   computeElements() {
    super.computeElements();
    this.elements.splice(this.elements.indexOf(this.requestedElement), 1);
   }

   reset(){
     super.reset();
     this.title = this.get("binaryInsertTitle");
   }

   generateDefinition(): any {
    let definition = super.generateDefinition();
    definition.image = "./assets/images/binary_insert.png";
    return definition;
  }

  /** computes the elements */
  changeElements() {
    this.elementS = this.elementS.trim();
    this.elements = this.elementS.split(",");
    if (this.elementType == 'number') {
      this.elements = this.elements.map(v => +v);
      this.elements = this.elements.sort((a, b) => +a -+b);
    }
    this.elementS = this.elements.toString();

  }
}
